import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BackendService,
  HttpOptions,
  PaginatedResponseModel,
} from '@ipg/ngx-frontend-toolset';
import { AuditLog, AuditLogUser } from '../audit-logs.model';

@Injectable({
  providedIn: 'root',
})
export class AuditLogsService {
  private readonly _backend = inject(BackendService);

  getAll(options?: HttpOptions): Observable<PaginatedResponseModel<AuditLog[]>> {
    return this._backend.get('/audit-logs', options);
  }

  getResources(): Observable<string[]> {
    return this._backend.get('/audit-logs/resources');
  }

  getActions(resource?: string): Observable<string[]> {
    const options: HttpOptions = resource ? { params: { resource } } : {};
    return this._backend.get('/audit-logs/actions', options);
  }

  getUsers(): Observable<AuditLogUser[]> {
    return this._backend.get('/audit-logs/users');
  }

  unshield(id: string, options?: HttpOptions): Observable<AuditLog> {
    return this._backend.post(`/audit-logs/${id}/unshield`, {}, options);
  }
}
